//needs to align with the url
export const ANR_ID = "applewoodnissanrichmond";
export const TRIAL = "trial";
export const ANL_ID = "applewoodnissanlangley";
export const ANS_ID = "applewoodnissansurrey";
export const AWF_ID = "applewoodford";
export const AGM_ID = "applewoodgm";
export const AMI_ID = "applewoodmitsubishi";
export const AKS_ID = "applewoodkiasurrey";
export const APC_ID = "applewoodperformancecenter";
export const AKL_ID = "applewoodkialangley";
export const AMS_ID = "applewoodmazda";
export const MNB_ID = "morreynissanburnaby";
export const MVB_ID = "morreyvolvocarsburnaby";
